import './comment-templates.scss'
import templateUrl from './comment-templates.html'
const CommentTemplatesComponent = {
  bindings: {
    project: '<'
  },
  require: {
    modalCtrl: '^^cdblModal'
  },

  templateUrl,
  controller: class CommentTemplatesComponent {
    constructor (Storage, UserService, ProjectService, ModalService, $timeout, SegmentAnalytics, $http, Configuration, UtilService, CommentTemplatesService, $mdMedia) {
      'ngInject'
      this._identify = 'CommentTemplatesComponent'
      this.Storage = Storage
      this.UserService = UserService
      this.ProjectService = ProjectService
      this.ModalService = ModalService
      this.SegmentAnalytics = SegmentAnalytics
      this.$timeout = $timeout
      this.$http = $http
      this.Configuration = Configuration
      this.UtilService = UtilService
      this.CommentTemplatesService = CommentTemplatesService
      this.$mdMedia = $mdMedia

      this.isLoading = false
      this.selectedTemplate = null
      this.searchText = ''
      this.tags = []
      this.templateList = []
      this.categoriesUnique = []
      this.phasesUnique = []
      this.mobileTemplate = 'list' // 'list' / 'view'
    }

    isDesktop () {
      return this.$mdMedia('gt-md')
    }
    closeViewOnMobile () {
      this.selectedTemplate = null
    }
    isViewVisible () {
      if (this.isDesktop()) {
        return true
      }

      return !!this.selectedTemplate
    }
    showMobileBack () {
      return !this.isDesktop()
    }

    $onInit () {
      this.templateList = this.CommentTemplatesService.getTemplateList()
      this.categoriesUnique = [...new Set(this.templateList.flatMap(({ categories }) => categories))]
      this.phasesUnique = [...new Set(this.templateList.flatMap(({ phase }) => phase))]
      this.selectedTemplate = null // this.templateList.length ? this.templateList[0] : null // Default selection
      this.SegmentAnalytics.trackEvent('Comment template modal opened', {
        projectId: this.ProjectService.project?.id
      })
    }

    scrollTo (id) {
      this.$timeout(() => {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    }

    // Filter function
    filteredTemplates () {
      return this.templateList.filter((template) => {
        const searchText = this.searchText.toLowerCase()
        return (
          (!searchText || template.label.toLowerCase().includes(searchText) || template.categories.some(cat => cat.toLowerCase().includes(searchText))) &&
          (!this.selectedCategory || template.categories.includes(this.selectedCategory)) &&
          (!this.selectedPhase || template.phase.includes(this.selectedPhase))
        )
      })
    }
    resetFilters () {
      this.searchText = ''
      this.selectedCategory = ''
      this.selectedPhase = ''
    }

    replaceTokens (contentWithTokens) {
      let content = contentWithTokens
      const project = this.ProjectService.project

      if (project) {
        const expertName = this.UserService.user.firstName
        const clientName = project.client && project.client.fullName
        if (clientName) {
          content = content.replaceAll('[clientName]', clientName)
        }
        if (expertName) {
          content = content.replaceAll('[expertName]', expertName)
        }
        content = content.replaceAll('[projectTitle]', `*${project.title}*`)
      }

      return content
    }

    applyTemplate ($event) {
      const content = this.replaceTokens($event.variant.content)

      this.SegmentAnalytics.trackEvent('Comment template used', {
        template: $event.template.label,
        variant: $event.variant.label,
        templateId: $event.template.id,
        variantId: $event.variant.id,
        projectId: this.ProjectService.project?.id
      })
      this.modalCtrl.resolve(content)
    }

    copyTemplate ($event) {
      const content = this.replaceTokens($event.variant.content)
      this.UtilService.copyContent2Clipboard(content)

      this.SegmentAnalytics.trackEvent('Comment template copied', {
        template: $event.template.label,
        variant: $event.variant.label,
        templateId: $event.template.id,
        variantId: $event.variant.id,
        projectId: this.ProjectService.project?.id
      })
      this.modalCtrl.resolve()
    }

    selectTemplate (template) {
      this.selectedTemplate = template
    }

    deselectTemplate () {
      this.selectedTemplate = null
    }

    closeDialog () {
      this.modalCtrl.resolve(true)
    }
  }
}

export default CommentTemplatesComponent
